import { LeagueNaming } from "@/types/league.types";

import { LeagueNamingContext } from "./LeagueNamingContext";

export const LeagueNamingContextProvider = ({
  naming,
  children,
}: {
  naming: LeagueNaming;
  children: React.ReactNode;
}) => {
  return <LeagueNamingContext.Provider value={naming}>{children}</LeagueNamingContext.Provider>;
};
